import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import styled from 'styled-components';
import createTheme from 'styled-variants';
import { pxToRems } from '@awaze/design-system.utils.react';
import { CloseIcon } from './icon';
const commonStyling = ({ theme }) => ({
    backgroundColor: 'transparent',
    color: theme.ColorThemeLink,
    border: '1px solid',
});
const variants = ({ theme }) => ({
    low: {
        borderColor: 'transparent',
        color: theme.ColorButtonOutlineSecondaryText,
        '&:hover': {
            color: theme.ColorButtonOutlineSecondaryTextHover,
        },
    },
    medium: {
        borderColor: theme.ColorBlackOpacity20,
        color: theme.ColorButtonOutlineSecondaryText,
        '&:hover': {
            borderColor: theme.ColorBlackOpacity30,
            color: theme.ColorButtonOutlineSecondaryTextHover,
        },
    },
    high: {
        backgroundColor: theme.ColorButtonSolidSecondaryBackground,
        color: theme.ColorButtonSolidSecondaryText,
        borderColor: theme.ColorButtonSolidSecondaryBackground,
        '&:hover': {
            borderColor: theme.ColorButtonSolidSecondaryBackgroundHover,
            backgroundColor: theme.ColorButtonSolidSecondaryBackgroundHover,
        },
    },
});
const ChipTheme = createTheme('Chip', commonStyling).addVariant('variant', variants);
const ChipThemed = styled.button(ChipTheme);
export const ChipStyled = styled(ChipThemed) `
  display: flex;
  align-items: center;
  height: 28px;
  padding: 2px 6px 2px 8px;
  border-radius: 28px;
  line-height: ${({ theme }) => pxToRems(theme.FontTextText100MidLineHeight)};
  font-size: ${({ theme }) => pxToRems(theme.FontTextText100MidFontSize)};
  cursor: pointer;
  transition: background-color 100ms ease, color 100ms ease,
    border-color 100ms ease;

  &:hover {
    svg {
      fill: ${({ theme, variant }) => variant === 'high'
    ? theme.ColorWhiteOpacity100
    : theme.ColorButtonSolidSecondaryBackgroundHover};
    }
  }
`;
export const StyledIcon = styled.span `
  display: flex;
  margin-left: 8px;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;

  svg {
    fill: ${({ theme, variant }) => variant === 'high'
    ? theme.ColorWhiteOpacity100
    : theme.ColorButtonSolidSecondaryBackground};
  }
`;
/**
 * A component with a changeable icon that triggers a callback when clicked
 */
export const Chip = memo(({ variant = 'medium', text, ariaLabel, onClick = () => null, icon = _jsx(CloseIcon, {}), }) => {
    return (_jsxs(ChipStyled, { variant: variant, "aria-label": ariaLabel, "data-testid": variant, onClick: onClick, children: [_jsx("span", { children: text }), _jsx(StyledIcon, { variant: variant, children: icon })] }));
});
//# sourceMappingURL=chip.js.map